import { renderRichText, storyblokEditable } from '@storyblok/react';
import clsx from 'clsx';
import { FC } from 'react';
import { RichTextWithImageStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { Link } from 'atoms/Link/Link';
import { ReactMarkdown } from 'molecules/Markdown';
import styles from './styles.module.css';

export const TextImageBlock: FC<{ blok: RichTextWithImageStoryblok }> = ({
  blok,
}) => {
  const image = (
    <Image
      src={blok.image.filename}
      alt={blok.image.alt}
      className={clsx(
        styles.textBlockImage,
        blok.upscaledImage && styles.upScaledEl,
      )}
    />
  );

  return (
    <div
      className={clsx(
        styles.imageTextBlock,
        blok.upscaledImage && styles.upScaledImage,
      )}
      {...storyblokEditable(blok)}
    >
      {blok?.linkForImage?.url ? (
        <Link
          className={styles.imageWrapper}
          href={blok.linkForImage.url}
          target="_blank"
        >
          {image}
        </Link>
      ) : (
        <div className={styles.imageWrapper}>{image}</div>
      )}
      <div className={clsx(blok.upscaledImage && styles.textblockContainer)}>
        <ReactMarkdown
          className={styles.imageBlockText}
          text={renderRichText(blok.text)}
        />
      </div>
    </div>
  );
};
